import { fromJS } from 'immutable';
import regexMap from '../../../../utils/regexMap';
import * as actionType from "./actionType";
const initialState = fromJS({
    countries: [],
    states: []
});


const suggestACharity = (state = initialState, action) => {  

    switch(action.type) {
        case actionType.dropDownMappingSuccessType:            
            return state.setIn(["countries"], action.payload.countries)
            .setIn(["states"], action.payload.states);
        case actionType.dropdDownMappingFailType:
        case actionType.suggestCharityFailType:
            return state.setIn(["error"], action.error);
        case actionType.validateFieldsType:
            const {
                cname,
                ein,
                addr1,
                addr2,
                addr3,
                zipcode,
                country,      
                stateInput,
                city,
                selectType,
                firstName,
                lastName,
                contactInfo
            } = action.payload;

            const required = !!cname && !!addr1 && !!zipcode && !!stateInput && !!country && !!city;
            const lengthCheck = required ? cname.length > 1 && city.length > 1 && stateInput.length > 1: false;
            const contactReq = !firstName && !lastName && !selectType ? true: ((selectType && contactInfo) ? true: false);
            let contactValid = true, validZip = false, validContactName = true;
            if((firstName || lastName || selectType) && selectType === 'Phone') contactValid = regexMap.phone.test(contactInfo);
            else if((firstName || lastName || selectType) && selectType === 'Email') contactValid = regexMap.email.test(contactInfo);
            if((firstName && !lastName) || (!firstName && lastName)) validContactName = false;
            else if(firstName && lastName) validContactName = regexMap.spaceRegex.test(firstName) && regexMap.spaceRegex.test(lastName);
            const validBaseFields =  (ein?regexMap.einRegex.test(ein): true) && regexMap.spaceRegex.test(cname) && regexMap.spaceRegex.test(addr1) && regexMap.spaceRegex.test(city);
            if(country.toString() === "0") validZip = regexMap.uszipCode.test(zipcode);
            else validZip = regexMap.spaceRegex.test(zipcode);
            const vAddr2 = !addr2 ? true: regexMap.spaceRegex.test(addr2);
            const vAddr3 = !addr3 ? true: regexMap.spaceRegex.test(addr3);
            const stateValid = country.toString() !== "0" ? regexMap.state.test(stateInput): true;
            const bVal = required && contactReq && contactValid && validBaseFields && validZip && vAddr2 && vAddr3 && stateValid && validContactName && lengthCheck;
            return state.setIn(["validation"], bVal);

        case actionType.clearValidationType:
            return state.setIn(["validation"], action.payload);
        case actionType.suggestCharitySuccessType:
            let suggestResponse = action.payload;
            suggestResponse.showEinPopUp = suggestResponse.isExisting;            
            return state.setIn(["suggestPost"], suggestResponse);
        case actionType.changePopUpStatusType:
            let suggestEinPop = action.payload;
            suggestEinPop.showEinPopUp = suggestEinPop.showEinPopUp === true ? false: true;
            return state.setIn(["suggestPost"], suggestEinPop);
        case actionType.addtoSavedCharitySuccessType:
            return state.setIn(["savedCharity"], action.payload.granteeOrgAliasId);
        case actionType.clearCharityListType:
                return state.setIn(["savedCharity"], "")
                        .setIn(["suggestPost"], "");
        default:
            return state;
                
    }

}

export default suggestACharity;